import VatSummaryResourceModel from '../../generated/types/model/resource/VatSummaryResourceModel';

export default class VatSummaryResourceViewModel extends VatSummaryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
